import { Box, Grid } from '@mui/material';
import { FormikProps } from 'formik';
import { useTranslation } from 'react-i18next';
import { FormikCalendar, FormikInputPhone, FormikInputSelect, FormikInputString, H3, P1R } from 'src/components';
import config from 'src/config';
import { themeColors } from 'src/theme';
import { ListType } from 'src/types';

type Props = {
  formik: FormikProps<any>;
  yardOptions: ListType[];
  gfOptions: ListType[];
};

const RosterDialogContent = ({ formik, yardOptions, gfOptions }: Props) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ p: 4, bgcolor: themeColors.grayLight, borderRadius: '4px' }}>
      <H3 sx={{ display: 'inline-block', mb: 1 }}>{t('splitRosterPage.rosterOwner')}</H3>
      <FormikInputSelect formik={formik} field="newOwner" label={t('splitRosterPage.selectNewOwner')} options={gfOptions} disableClearable />
      <H3 sx={{ display: 'inline-block', mb: 1 }}>{t('rosterPage.generalInfo')}</H3>
      <FormikInputString formik={formik} field="name" label={t('rosterPage.displayName')} autoFocus isOptional />
      <FormikInputSelect formik={formik} field="yardFK" label={t('rosterPage.yardFK')} options={yardOptions} disableClearable />
      <FormikCalendar formik={formik} field="startDate" label="Start Day" />
      <FormikInputSelect
        formik={formik}
        field="startTime"
        label={t('rosterPage.startTime')}
        options={config.times.map((value: string) => ({
          key: value,
          value,
        }))}
        disableClearable
      />
      <H3 sx={{ display: 'inline-block', mt: 1, mb: 1 }}>{t('rosterPage.notes')}</H3>
      <Grid item>
        <FormikInputString formik={formik} field="notes" label={t('rosterPage.notes')} isOptional multiline rows={6} />
        <Box sx={{ mt: -2, display: 'flex', justifyContent: 'right' }}>
          <P1R sx={{ color: themeColors.grayPlaceholders }}>{formik.values.notes?.length || 0}/500</P1R>
        </Box>
      </Grid>
      <H3 sx={{ display: 'inline-block', mt: 1, mb: 1 }}>{t('rosterPage.alternateContact')}</H3>
      <FormikInputString formik={formik} field="contactFullName" label={t('rosterPage.fullName')} isOptional />
      <FormikInputPhone formik={formik} field="contactPhone" label={t('splitRosterPage.phoneNumber')} isOptional />
      <FormikInputString formik={formik} field="contactEmail" label={t('splitRosterPage.emailAddress')} isOptional />
    </Box>
  );
};

export default RosterDialogContent;
